const sendEth = {
  label: 'Send ETH',
  value: 'send eth',
  subSteps: [
    'First create a deposit. This will include inputting the recipiant\'s address in the send box and clicking send to Mixer.',
    'Then follow the prompts on Metamask, as soon as the transaction is sent you will receive a secret',
    'Copy the secret somewhere safe or save it as a file. You will need this to withdraw your funds.',
    'Without the secret your funds will be locked up in the contract and lost forever!'
  ]
};

const shareTheSecret = {
  label: 'Share the Secret',
  value: 'share the secret',
  subSteps: [
    'Now you need to call the withdraw function.',
    'To maintain privacy this should be done from a wallet with no connection to your depositing wallet.'
  ]
};

const receiveEth = {
  label: 'Receive ETH',
  value: 'receive eth',
  subSteps: [
    'The secret contains all the information you need to generate the proof to receive the funds.',
    'Copy paste the secret into the withdrawal text box.',
    'Wait as the proof is generated, this should take approximately 45 seconds.',
    'Metamask will pop up when done, confirm the transaction and wait for it to be mined.',
    'At this point your funds will be successfully mixed!'
  ]
};

export const steps = [sendEth, shareTheSecret, receiveEth];
